export default __webpack_public_path__ + "static/media/FP_FM_GM_F.0af5e36c.png";